import { jsx as l } from "react/jsx-runtime";
import "react";
import { classNames as a } from "../../utilities/index.js";
const c = ({ align: o, justify: s, reverse: x, noGutters: r, verticalGutters: e, largeGutters: m, className: p, children: f, ...t }) => {
  const w = a({
    "sash-Row flex flex-wrap": !0,
    "flex-row": !x,
    "flex-row-reverse": x,
    "[&>*]:px-2 -mx-2": !r && !m,
    "[&>*]:px-4 -mx-4": !r && m,
    "[&>*]:py-3 xl:[&>*]:py-4": e,
    [`items-${o}`]: o,
    [`justify-${s}`]: s,
    [p]: p
  });
  return /* @__PURE__ */ l(
    "div",
    {
      className: w,
      ...t,
      children: f
    }
  );
}, d = c;
export {
  d as default
};
